import React from 'react';
import Icon from '@amzn/meridian/icon';
import checkLargeTokens from '@amzn/meridian-tokens/base/icon/check-large';
import Tooltip from '@amzn/meridian/tooltip';

interface YesCheckProps {
  className?: string;
  tooltip: string;
}

const YesCheck = ({ className, tooltip }: YesCheckProps) => (
  <Tooltip position='top' title={tooltip}>
    <Icon className={className} tokens={checkLargeTokens} />
  </Tooltip>
);

export default YesCheck;
